module.exports = __webpack_public_path__ + "29da316fe7de4ab014609910e5a77267.svg";